/**
 * F09 v2 (E41) — legacy admin URLs kept as redirects:
 *   /verifications/:id      → /verifications/requests/:id
 *   /users/:userId/verify   → /verifications/direct (pre-filled with the player)
 */
import { Navigate, useParams } from 'react-router-dom';

export function LegacyVerificationDetailRedirect() {
  const { id = '' } = useParams<{ id: string }>();
  return <Navigate to={`/verifications/requests/${encodeURIComponent(id)}`} replace />;
}

export function LegacyUserVerifyRedirect() {
  const { userId = '' } = useParams<{ userId: string }>();
  const q = new URLSearchParams({ entityType: 'player', entityId: userId });
  return <Navigate to={`/verifications/direct?${q.toString()}`} replace />;
}
